import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pause-sharp",
  "use": "icon-pause-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-pause-sharp\"><title>Pause</title><path d=\"M224 432h-80V80h80zM368 432h-80V80h80z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol